import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useOutsideClick,
  Box,
} from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { useRef } from 'react';
import { FilterClose } from './UiItems/FilterClose';
import { FilterFooter } from './UiItems/FilterFooter';

import { EmployeeSize } from '@/assets/icons/filters';
import { KText } from '@/ui-library/components/text';
export const FilterWrapper = ({
  children,
  filterConfig = {},
  modalActions = {},
  onAction = () => {},
  filterActions = () => {},
  icon = EmployeeSize,
  selected = [],
  currentlySelected = [],
  clearSearchTerm = () => {},
}) => {
  const ref = useRef(null);

  const { isOpen = false, onClose, onToggle } = modalActions;
  const {
    id: filterId,
    label: filterTitle,
    valueKey,
    isMultiple = true,
  } = filterConfig;

  const handleFilterAction = (actionType) => {
    if (actionType === 'reset') {
      filterActions({ type: 'clear', value: selected, key: filterId });
    } else if (actionType === 'apply') {
      filterActions({ type: 'apply', value: selected, key: filterId });
    }
    onAction();
    onClose();
    clearSearchTerm();
  };

  useOutsideClick({
    ref: ref,
    handler: () => {
      onAction();
      onClose();
    },
  });

  return (
    <Box ref={ref}>
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <Flex
            bg={'primary-50'}
            px="sm"
            borderRadius="xs"
            cursor="pointer"
            onClick={onToggle}
            alignItems="center"
            justifyContent={'center'}
            gap="3px"
            h="34px"
          >
            <KText
              size="sm-semi-bold"
              color="primary-600"
              lineHeight={'1.313rem'}
            >
              {filterTitle}:
            </KText>
            <Flex alignItems="center" maxW="240px">
              <KText
                fontSize="sm"
                color="primary-600"
                isTruncated
                flex="1"
                enableTooltip={true}
                tooltipText={selected[0]?.[valueKey]}
              >
                {selected[0]?.[valueKey]}
              </KText>
              {selected?.length > 1 && (
                <KText
                  as="span"
                  size="sm-medium"
                  color="primary-600"
                  flexShrink={0}
                >
                  {' '}
                  +{selected?.length - 1}
                </KText>
              )}
            </Flex>
            {selected?.length > 0 && (
              <FilterClose
                onClose={() => handleFilterAction('reset')}
                color="primary-600"
              />
            )}
          </Flex>
        </PopoverTrigger>
        <PopoverContent width="340px">
          <PopoverBody padding="lg">
            <Box minH="100px">{children}</Box>
            {isMultiple && (
              <FilterFooter
                selected={currentlySelected}
                onApply={() => handleFilterAction('apply')}
                onClear={() => handleFilterAction('reset')}
              />
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
